import CourseListingMainComponent from "./CourseListingMainComponent";

const CourseListingPopularCourse =()=>{


    return (<>
        <CourseListingMainComponent
        isAllCourse={false}
        isMyCourse={false}
        isFilterShow={true}
        isPopular={true}
        tabKey={"popular"} />
        </>)
}
export default CourseListingPopularCourse;